export default __webpack_public_path__ + "static/Graphik-Bold-Web-114730c4c75231c9b1c5627cf3496f68.woff";